import { useContext } from "react";
import stateContext from "../../Context/StateContext";
import { Text } from '@react-three/drei';
import DimensionLine from "./DimensionLine";
import CylinderLine from "./CylinderLine";

function Dimension() {
    const globalState = useContext(stateContext);
    let width = parseFloat(globalState.plateSize?.width)
    let height = parseFloat(globalState.plateSize?.height)
    let offset = 3

    let widthDimP1, widthDimP2, widthTextPos
    if (globalState.selectedCharm === "shape-none" || globalState.selectedCharm === "") {
        widthDimP1 = [0, -height - offset, 0]
        widthDimP2 = [width, -height - offset, 0]
        widthTextPos = [width / 2, -height - offset * 2, 0]
    }else {
        widthDimP1 = [0,  offset, 0]
        widthDimP2 = [width, offset, 0]
        widthTextPos = [width / 2, offset * 2, 0]
    }

    let heightTextPos = [width + offset * 2.5, -height / 2, 0]
    let heightDimP1 = [width + offset, 0, 0]
    let heightDimP2 = [width + offset, -height, 0]

    let topLeft = [0, 0, 0]
    let topRight = [width, 0, 0]
    let bottomLeft = [0, -height, 0]
    let bottomRight = [width, -height, 0]


    return (
        <object3D name="dimensions">
            {width  && (
               <>
                    
                    <Text
                        position={widthTextPos}
                        fontSize={3}
                        color="grey"
                        maxWidth={100}
                        lineHeight={1}
                        letterSpacing={0.02}
                        textAlign="center"
                        font="https://fonts.gstatic.com/s/roboto/v27/KFOmCnqEu92Fr1Mu4mxP.ttf"
                        anchorX="center"
                        anchorY="middle"
                    >
                        {(width/10)?.toFixed(2)} {/* convert into cm */}
                    </Text>
                    <Text
                        position={heightTextPos}
                        fontSize={3}
                        color="grey"
                        maxWidth={100}
                        lineHeight={1}
                        letterSpacing={0.02}
                        textAlign="center"
                        font="https://fonts.gstatic.com/s/roboto/v27/KFOmCnqEu92Fr1Mu4mxP.ttf"
                        anchorX="center"
                        anchorY="middle"
                    >
                        {(height/10)?.toFixed(2)} {/* convert into cm */}
                    </Text>
                  
                    <DimensionLine inPo1={widthDimP1} inPo2={widthDimP2} />
                    <DimensionLine inPo1={heightDimP1} inPo2={heightDimP2} />

                    <CylinderLine inPo1={topLeft} inPo2={topRight} />
                    <CylinderLine inPo1={topRight} inPo2={bottomRight} />
                    <CylinderLine inPo1={bottomRight} inPo2={bottomLeft} />
                    <CylinderLine inPo1={bottomLeft} inPo2={topLeft} />
                
               </>
            )}
        </object3D>
    )
}

export default Dimension;